export interface IMenuSearchModel {
  menuId: number;
  tenantId: number;
  locationId: number;
  Search: string,
  SkipCount: number;
  MaxResultCount: number;
}
